const OFFSET_FULLWIDTH = 65248 
const REGEX_FULLWIDTH =/[Ａ-Ｚａ-ｚ０-９]/g // alphanumeric characters
const SPECIAL_CHAR_MAP = {
  '－': '-', // full-width hyphen
  '！': '!',
  '：': ':',
  '（': '(',
  '）': ')',
  '＋': '+',
  '，': ',',
  '．': '.',
  '／': '/',
  '％': '%',
  '＠': '@',
  '［': '[',
  '］': ']',
  '　': ' ',
};

export function convertFullWidthToHalfWidthIncludeSpecialCharacter(input) {
  return input
    .replace(REGEX_FULLWIDTH, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) - OFFSET_FULLWIDTH);
    })
    .replace(/[\uFF00-\uFFEF]/g, function (ch) {
      return SPECIAL_CHAR_MAP[ch] || ch;
    });
}

export function convertFullWidthToHalfWidth(input) {
  return input.replace(REGEX_FULLWIDTH, function (match) {
    return String.fromCharCode(match.charCodeAt(0) - OFFSET_FULLWIDTH);
  });
}

export function convertNestedFullWidthToHalfWidth(data) {
  if (typeof data === 'string') {
    return convertFullWidthToHalfWidth(data);
  } else if (Array.isArray(data)) {
    return data.map(convertNestedFullWidthToHalfWidth);
  } else if (typeof data === 'object' && data !== null) {
    const convertedData = {};
    for (const key in data) {
      convertedData[key] = convertNestedFullWidthToHalfWidth(data[key]);
    }
    return convertedData;
  }
  return data;
}